export function setupStringPrototypes() {
  Object.defineProperty(String.prototype, "capitalize", {
    value: function () {
      return this.charAt(0).toUpperCase() + this.slice(1)
    },
    enumerable: false
  })

  Object.defineProperty(String.prototype, "title", {
    value: function () {
      return this.split("-")
        .join(" ")
        .split("_")
        .join(" ")
        .split(" ")
        .map((word) => word.capitalize())
        .join(" ")
    },
    enumerable: false
  })
}
